import { ApiProperty } from "@nestjs/swagger";

export class TemperatureLogDto {
    @ApiProperty()
    tempLogId: number;
    @ApiProperty()
    loadStatus:string;
    @ApiProperty()
    uid:string;
    @ApiProperty()
    deptName: string;
    @ApiProperty()
    deptCode:string;
    @ApiProperty()
    unitId:number;
    @ApiProperty()
    module: string;
    @ApiProperty()
    subModule: string;
    @ApiProperty()
    date: any;
    @ApiProperty()
    day: number;
    @ApiProperty()
    month: number;
    @ApiProperty()
    hour: number;
    @ApiProperty()
    minutes: number;
    @ApiProperty()
    temperature: number;
    @ApiProperty()
    uom: string;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string;
    @ApiProperty() 
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string;
    @ApiProperty() 
    versionFlag: number;
    constructor( tempLogId: number,loadStatus:string,uid:string, deptName: string,deptCode:string,unitId:number, module: string, subModule: string, date: any, day: number, month: number, hour: number, minutes: number, temperature:number, uom: string, createdAt: Date, createdUser: string,  updatedAt: Date, updatedUser: string,  versionFlag: number){
        this.tempLogId = tempLogId;
        this.loadStatus =loadStatus;
        this.uid = uid;
        this.deptName = deptName;
        this.deptCode = deptCode;
        this.unitId = unitId;
        this.module = module;
        this.subModule = subModule;
        this.date = date;
        this.day = day;
        this.month = month;
        this.hour = hour;
        this.minutes = minutes;
        this.temperature = temperature;
        this.uom = uom;
        this.createdAt = createdAt;
        this.createdUser = createdUser;
        this.updatedAt = updatedAt;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
  }

}